<template>
  <div class="notice-manager">
    <Card :padding="10" title="编辑企业信息" shadow>
      <Form ref="formValidate" :model="formValidate" :label-width="120">
        <FormItem label="分类" prop="etype" :rules="{required: true, message: '请选择分类'}">
          <Select v-model="formValidate.etype" placeholder="请选择企业分类">
            <Option v-for="item in typeList" :key="item" :value="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="企业名称" prop="name" :rules="{required: true, message: '请输入企业名称', max: 100}">
          <Input v-model="formValidate.name" placeholder="请输入企业名称"></Input>
        </FormItem>
        <FormItem label="所属街道/园区" prop="streetPark" :rules="{required: false, max: 255, message: '长度不能超过255个字'}">
          <Input v-model="formValidate.streetPark" placeholder="请输入所属街道 / 园区"></Input>
        </FormItem>
        <FormItem v-if="showBatchNo" label="批次" prop="batchNo" :rules="{required: false, max: 100, message: '长度不能超过100个字'}">
          <Input v-model="formValidate.batchNo" placeholder="请输入批次（如：第一批）"></Input>
        </FormItem>
        <FormItem v-if="showMainField" label="主营领域" prop="mainField" :rules="{required: false, max: 500, message: '长度不能超过500个字'}">
          <Input v-model="formValidate.mainField" placeholder="请输入主营领域"></Input>
        </FormItem>
        <FormItem v-if="showCertTime" label="认定时间" prop="certTime" :rules="{required: false, max: 500, message: '长度不能超过500个字'}">
          <Input type="textarea" :rows="3" v-model="formValidate.certTime" placeholder="请输入认定时间"></Input>
        </FormItem>
        <FormItem label="信用代码" prop="code" :rules="{required: false, message: '长度不能超过50个字', max: 50}">
          <Input v-model="formValidate.code" placeholder="统一社会信用代码"></Input>
        </FormItem>
        <FormItem label="注册地址" prop="registerAddress" :rules="{required: false, message: '长度不能超过100个字', max: 100}">
          <Input v-model="formValidate.registerAddress" placeholder="企业注册地址"></Input>
        </FormItem>
        <FormItem label="办公地址" prop="address" :rules="{required: false, message: '长度不能超过100个字', max: 100}">
          <Input v-model="formValidate.address" placeholder="企业实际办公地址"></Input>
        </FormItem>
        <FormItem label="行业领域" prop="industry" :rules="{required: false, message: '长度不能超过50个字', max: 50}">
          <AutoComplete
              v-model="formValidate.industry"
              :data="industryList"
              placeholder="行业领域" />
        </FormItem>
        <FormItem label="企业资质" prop="qualification" :rules="{required: false, message: '长度不能超过50个字', max: 50}">
          <AutoComplete
              v-model="formValidate.qualification"
              :data="qList"
              placeholder="企业资质" />
        </FormItem>
        <FormItem label="承担项目" prop="undertakeProject" :rules="{required: false, message: '长度不能超过100个字', max: 100}">
          <Input v-model="formValidate.undertakeProject" placeholder="XXX省级项目、XXX市级项目"></Input>
        </FormItem>
        <FormItem label="营业收入" prop="income2021" :rules="{required: false}">
          <Select v-model="formValidate.income2021" placeholder="营业收入" clearable>
            <Option v-for="item in feeList" :key="item" :value="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="研发投入" prop="putin2021" :rules="{required: false}">
          <Select v-model="formValidate.putin2021" placeholder="研发投入" clearable>
            <Option v-for="item in feeList" :key="item" :value="item">{{item}}</Option>
          </Select>
        </FormItem>
        <FormItem label="核心产品简介" prop="productIntroduce" :rules="{required: false}">
          <editor v-model="formValidate.productIntroduce"></editor>
        </FormItem>
        <FormItem label="企业技术需求" prop="requirements" :rules="{required: false, message: '长度不能超过500个字', max: 500}">
          <Input type="textarea" v-model="formValidate.requirements" placeholder="企业技术需求"></Input>
        </FormItem>
        <FormItem label="联系人名字" prop="contactName" :rules="{required: false, message: '长度不能超过20个字', max: 20}">
          <Input v-model="formValidate.contactName" placeholder="联系人名字"></Input>
        </FormItem>
        <FormItem label="联系人职位" prop="contactJob" :rules="{required: false, message: '长度不能超过20个字', max: 20}">
          <Input v-model="formValidate.contactJob" placeholder="联系人职位"></Input>
        </FormItem>
        <FormItem label="联系人手机号" prop="contactPhone" :rules="{required: false, message: '长度不能超过20个字', max: 20}">
          <Input v-model="formValidate.contactPhone" placeholder="联系人手机号"></Input>
        </FormItem>
        <FormItem label="缩略图" prop="thumbnail">
            <CustomUpload v-model="formValidate.thumbnail"></CustomUpload>
        </FormItem>
        <FormItem label="图片" prop="mainPic" :rules="{required: false}">
            <CustomUpload v-model="formValidate.mainPic"></CustomUpload>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')" :disabled="showNotEdit">保存信息</Button>
        </FormItem>
      </Form>
    </Card>

  </div>
</template>

<script>
import editor from '@/components/common/Editor';

export default {
  name: 'addEnterpriseManager',
  data() {
    return {
      showNotEdit: false,
      industryList: ["电子信息","生物与新医药","航空航天","新材料","高技术服务","新能源与节能","资源与环境","先进制造与自动化","其他"],
      qList: ["高新技术企业","江苏省工程技术研究中心"],
      feeList: ["100万元以下","100万元-500万元","500万元-1000万元","1000万元-1500万元","1500万元-2000万元","2000万元以上"],
      typeList: ['科技型中小企业', '高新技术企业', '规上企业', '瞪羚／独角兽及培育独角兽企业', '专精特新中小企业', '专精特新“小巨人”企业'],
      formValidate: {
        etype: '科技型中小企业',
        name: '',
        streetPark: '',
        batchNo: '',
        mainField: '',
        certTime: ''
      }
    }
  },
  computed: {
    showBatchNo() {
      return this.formValidate.etype === '科技型中小企业';
    },
    showMainField() {
      return this.formValidate.etype === '规上企业';
    },
    showCertTime() {
      const t = this.formValidate.etype || '';
      return (
        t === '瞪羚／独角兽及培育独角兽企业' ||
        t === '瞪羚/独角兽及培育独角兽企业' ||
        t === '专精特新中小企业' ||
        t.indexOf('小巨人') !== -1
      );
    }
  },
  components: {
    editor
  },
  created() {
    this.getEnterpirse();
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$http.post('/api/enterprise/save', this.formValidate).then(() => {
            this.$Message.success('保存成功');
          });
        }
      })
    },
    getEnterpirse(){
      this.$http.get('/api/enterprise/getEnterprise', {}).then(data => {
        if(data != null){
          this.formValidate = data;
          this.formValidate.industry = data.industry == null ? '' : data.industry;
          this.formValidate.qualification = data.qualification == null ? '' : data.qualification;
          if (!this.formValidate.streetPark && data.sname) {
            this.formValidate.streetPark = data.sname;
          }
        }else{
          this.showNotEdit = true;
          this.$Modal.error({title: '您不是企业用户，无法编辑企业信息！'})
        }
      });
    }
  }
}
</script>
